import layoutAdmin from "@/layouts/layoutAdmin.vue";
import pageNotFound from "@/views/utils/pageNotFound.vue";
import dashboard from "@/views/module/dashboard/dashboard.vue";
import moduleSetup from "@/views/module/administration/moduleManagement/moduleSetup.vue";
import warehouseSetup from "@/views/module/inventory/settingsManagement/warehouseSetup.vue";
import brandSetup from "@/views/module/inventory/settingsManagement/brandSetup.vue";
import manufactureSetup from "@/views/module/inventory/settingsManagement/manufactureSetup.vue";
import unitSetup from "@/views/module/inventory/settingsManagement/unitSetup.vue";
import secondaryUnitSetup from "@/views/module/inventory/settingsManagement/secondaryUnitSetup.vue";
import productTypeSetup from "@/views/module/inventory/settingsManagement/productTypeSetup.vue";
import categorySetup from "@/views/module/inventory/settingsManagement/categorySetup.vue";
import subCategorySetup from "@/views/module/inventory/settingsManagement/subCategorySetup.vue";
import colorSetup from "@/views/module/inventory/settingsManagement/colorSetup.vue";
import sizeSetup from "@/views/module/inventory/settingsManagement/sizeSetup.vue";
import exchangeRateList from "@/views/module/inventory/settingsManagement/exchangeRateList.vue";
import productSetup from "@/views/module/inventory/productManagement/productSetup.vue";
import productList from "@/views/module/inventory/productManagement/productList.vue";
import productMapping from "@/views/module/inventory/productManagement/productMapSetup.vue";
import supplierSetup from "@/views/module/inventory/supplierManagement/supplierSetup.vue";
import supplierList from "@/views/module/inventory/supplierManagement/supplierList.vue";
import supplierMapping from "@/views/module/inventory/supplierManagement/supplierMapSetup.vue";
import supplierTypeSetup from "@/views/module/inventory/supplierManagement/supplierTypeSetup.vue";
import customerTypeSetup from "@/views/module/inventory/customerManagement/customerTypeSetup.vue";
import invRequistion from "@/views/module/inventory/requistionManagement/invRequistion.vue";
import invRequistionRecord from "@/views/module/inventory/requistionManagement/invRequistionRecord.vue";
import viewRequisition from "@/views/module/inventory/requistionManagement/viewRequisition.vue";
import customerSetup from "@/views/module/inventory/customerManagement/customerSetup.vue";
import customerList from "@/views/module/inventory/customerManagement/customerList.vue";
import customerMapping from "@/views/module/inventory/customerManagement/customerMapSetup.vue";
import issueEntrySetup from "@/views/module/inventory/directIssueManagement/issueEntrySetup.vue";
import issueEntryRecord from "@/views/module/inventory/directIssueManagement/issueEntryRecord.vue";
import directReceive from "@/views/module/inventory/receiveManagement/directRecevie.vue";
import directRecevieRecord from "@/views/module/inventory/receiveManagement/directRecevieRecord.vue";
import viewDirectReceive from "@/views/module/inventory/receiveManagement/viewDirectReceive.vue";
import poReceive from "@/views/module/inventory/receiveManagement/poReceive.vue";
import poReceiveRecord from "@/views/module/inventory/receiveManagement/poReceiveRecord.vue";
import viewPoReceive from "@/views/module/inventory/receiveManagement/viewPoReceive.vue";
import lcReceive from "@/views/module/inventory/receiveManagement/lcReceive.vue";
import lcReceiveRecord from "@/views/module/inventory/receiveManagement/lcReceiveRecord.vue";
import addTransfer from "@/views/module/inventory/itemTransferManagement/addTransfer.vue";
import transferRecord from "@/views/module/inventory/itemTransferManagement/transferRecord.vue";
import inventoryRecords from "@/views/module/inventory/inventoryRecords.vue";
import inventoryDetails from "@/views/module/inventory/inventoryDetails.vue";
import requisitionDeliverySetup from "@/views/module/inventory/deliveryManagement/requisitionDeliverySetup.vue";
import requisitionDeliveryRecords from "@/views/module/inventory/deliveryManagement/requisitionDeliveryRecords.vue";
import salesInvoiceDeliverySetup from "@/views/module/inventory/deliveryManagement/salesInvoiceDeliverySetup.vue";
import salesInvoiceDeliveryRecords from "@/views/module/inventory/deliveryManagement/salesInvoiceDeliveryRecords.vue";
import gatePassSetup from "@/views/module/inventory/gatePassManagement/gatePassSetup.vue";
import gatePassRecords from "@/views/module/inventory/gatePassManagement/gatePassRecords.vue";
import gatePassInvoice from "@/views/module/inventory/gatePassManagement/gatePassInvoice.vue";
import requisitionDeliveryInvoice from "@/views/module/inventory/deliveryManagement/requisitionDeliveryInvoice.vue";
import salesInvoiceDeliveryInvoice from "@/views/module/inventory/deliveryManagement/salesInvoiceDeliveryInvoice.vue";
import saleInvoiceDeliveryOrder from "@/views/module/inventory/deliveryManagement/saleInvoiceDeliveryOrder.vue";
import viewIssueEntryInvoice from "@/views/module/inventory/directIssueManagement/viewIssueEntryInvoice.vue";
// reports
import productMappingReport from "@/views/module/inventory/reports/productMappingReports.vue";
import supplierMappingReport from "@/views/module/inventory/reports/supplierMappingReports.vue";
import stockReport from "@/views/module/inventory/reports/stockReports.vue";
import deliveryReports from "@/views/module/inventory/reports/deliveryReports.vue";
import gatePassReports from "@/views/module/inventory/reports/gatePassReports.vue";

export default [
  {
    path: "/inventory",
    name: "inventory",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: "Inventory",
    },
    children: [
      {
        path: "dashboard",
        meta: {
          breadcrumb: ["Dashboard"],
        },
        component: dashboard,
      },
      {
        path: "add-warehouse",
        name: "add-warehouse",
        meta: {
          breadcrumb: ["Setting", "Add Warehouse"],
        },
        component: warehouseSetup,
      },
      {
        path: "add-brand",
        name: "add-brand",
        meta: {
          breadcrumb: ["Setting", "Add Brand"],
        },
        component: brandSetup,
      },
      {
        path: "add-color",
        name: "add-color",
        meta: {
          breadcrumb: ["Setting", "Add Color"],
        },
        component: colorSetup,
      },
      {
        path: "add-manufacture",
        name: "add-manufacture",
        meta: {
          breadcrumb: ["Setting", "Add Manufacture"],
        },
        component: manufactureSetup,
      },
      {
        path: "add-secondary-unit",
        name: "add-secondary-unit",
        meta: {
          breadcrumb: ["Setting", "Add Secondary Unit"],
        },
        component: secondaryUnitSetup,
      },
      {
        path: "add-unit",
        name: "add-unit",
        meta: {
          breadcrumb: ["Setting", "Add Unit"],
        },
        component: unitSetup,
      },
      {
        path: "add-product-type",
        name: "add-product-type",
        meta: {
          breadcrumb: ["Setting", "Add Product Type"],
        },
        component: productTypeSetup,
      },
      {
        path: "add-size",
        name: "add-size",
        meta: {
          breadcrumb: ["Setting", "Add Size"],
        },
        component: sizeSetup,
      },
      {
        path: "add-category",
        name: "add-category",
        meta: {
          breadcrumb: ["Setting", "Add Category"],
        },
        component: categorySetup,
      },
      {
        path: "add-subcategory",
        name: "add-subcategory",
        meta: {
          breadcrumb: ["Setting", "Add Category"],
        },
        component: subCategorySetup,
      },
      // Product
      {
        path: "add-product",
        name: "add-product",
        meta: {
          breadcrumb: ["Product", "Add Product"],
        },
        component: productSetup,
      },
      {
        path: "product-list",
        name: "product-list",
        meta: {
          breadcrumb: ["Product", "Product List"],
        },
        component: productList,
      },
      {
        path: "product-mapping",
        name: "product-mapping",
        meta: {
          breadcrumb: ["Product", "Product Mapping"],
        },
        component: productMapping,
      },
      // Supplier
      {
        path: "add-supplier",
        name: "add-supplier",
        meta: {
          breadcrumb: ["Supplier", "Add Supplier"],
        },
        component: supplierSetup,
      },
      {
        path: "supplier-list",
        name: "supplier-list",
        meta: {
          breadcrumb: ["Supplier", "Supplier List"],
        },
        component: supplierList,
      },
      {
        path: "supplier-mapping",
        name: "supplier-mapping",
        meta: {
          breadcrumb: ["Supplier", "Supplier Mapping"],
        },
        component: supplierMapping,
      },

      // Supplier Management
      {
        path: "supplier-type",
        name: "supplier-type",
        meta: {
          breadcrumb: ["Supplier Management", "Add Supplier Type"],
        },
        component: supplierTypeSetup,
      },

      // Customer Management
      {
        path: "customer-type",
        name: "customer-type",
        meta: {
          breadcrumb: ["Customer Management", "Add Customer Type"],
        },
        component: customerTypeSetup,
      },

      {
        path: "currency-exchange-rate",
        name: "currency-exchange-rate",
        meta: {
          breadcrumb: ["Settings", "Exchange Rates"],
        },
        component: exchangeRateList,
      },

      // Requisition Management
      {
        path: "add-requistion",
        name: "add-requistion",
        meta: {
          breadcrumb: ["Requisition Management", "Add Requisition"],
        },
        component: invRequistion,
      },
      {
        path: "requistion-record",
        name: "requistion-record",
        meta: {
          breadcrumb: ["Requisition Management", "Requisition Record"],
        },
        component: invRequistionRecord,
      },
      {
        path: "view-requisition/:id",
        name: "view-requisition",
        meta: {
          breadcrumb: ["General Requisition", "View Requisition"],
        },
        component: viewRequisition,
      },
      {
        path: "add-customer",
        name: "add-customer",
        meta: {
          breadcrumb: ["Customer", "Add Customer"],
        },
        component: customerSetup,
      },
      {
        path: "customer-list",
        name: "customer-list",
        meta: {
          breadcrumb: ["Customer", "Customer List"],
        },
        component: customerList,
      },
      {
        path: "customer-mapping",
        name: "customer-mapping",
        meta: {
          breadcrumb: ["Customer", "Customer Mapping"],
        },
        component: customerMapping,
      },
      {
        path: "issue-entry",
        name: "issue-entry",
        meta: {
          breadcrumb: ["Direct Issue Management", "Issue Entry"],
        },
        component: issueEntrySetup,
      },
      {
        path: "issue-record",
        name: "issue-record",
        meta: {
          breadcrumb: ["Direct Issue Management", "Issue Record"],
        },
        component: issueEntryRecord,
      },
      {
        path: "view-issue-invoice",
        name: "view-issue-invoice",
        meta: {
          breadcrumb: ["Direct Issue Management", "View Issue Invoice"],
        },
        component: viewIssueEntryInvoice,
      },
      {
        path: "direct-receive",
        name: "direct-receive",
        meta: {
          breadcrumb: ["Direct Receive Management", "Direct Receive"],
        },
        component: directReceive,
      },
      {
        path: "direct-receive-records",
        name: "direct-receive-records",
        meta: {
          breadcrumb: ["Direct Receive Management", "Direct Record"],
        },
        component: directRecevieRecord,
      },
      {
        path: "view-direct-receive/:id",
        name: "view-direct-receive",
        meta: {
          breadcrumb: ["Direct Receive Management", "View Direct Receive"],
        },
        component: viewDirectReceive,
      },
      {
        path: "po-receive",
        name: "po-receive",
        meta: {
          breadcrumb: ["PO Receive Management", "PO Receive"],
        },
        component: poReceive,
      },
      {
        path: "po-receive-records",
        name: "po-receive-records",
        meta: {
          breadcrumb: ["PO Recieve Management", "PO Record"],
        },
        component: poReceiveRecord,
      },
      {
        path: "view-po-receive/:id",
        name: "view-po-receive",
        meta: {
          breadcrumb: ["PO Receive Management", "View PO Receive"],
        },
        component: viewPoReceive,
      },
      {
        path: "lc-receive",
        name: "lc-receive",
        meta: {
          breadcrumb: ["LC Receive Management", "LC Receive"],
        },
        component: lcReceive,
      },
      {
        path: "lc-receive-records",
        name: "lc-receive-records",
        meta: {
          breadcrumb: ["LC Recieve Management", "LC Record"],
        },
        component: lcReceiveRecord,
      },
      
      //Item Transfer
      {
        path: "add-transfer",
        name: "add-transfer",
        meta: {
          breadcrumb: ["Item Transfer", "Add Transfer"],
        },
        component: addTransfer,
      },
      {
        path: "transfer-record",
        name: "transfer-record",
        meta: {
          breadcrumb: ["Item Transfer", "Transfer Record"],
        },
        component: transferRecord,
      },

      // Inventory Records
      {
        path: "records",
        name: "inventory-records",
        meta: {
          breadcrumb: ["Inventory", "Inventory Records"],
        },
        component: inventoryRecords,
      },

      // Inventory Details (Transaction Log)
      {
        path: "details",
        name: "inventory-details",
        meta: {
          breadcrumb: ["Inventory", "Inventory Details"],
        },
        component: inventoryDetails,
      },
      
      //Delivery Management

      {
        path: "requisition-delivery",
        name: "requisition-delivery",
        meta: {
          breadcrumb: ["Inventory", "Requisition Delivery Setup"],
        },
        component: requisitionDeliverySetup,
      },
      {
        path: "requisition-delivery-records",
        name: "requisition-delivery-records",
        meta: {
          breadcrumb: ["Inventory", "Requisition Delivery Records"],
        },
        component: requisitionDeliveryRecords,
      },
      {
        path: "view-requisition-delivery-invoice",
        name: "view-requisition-delivery-invoice",
        meta: {
          breadcrumb: ["Inventory", "Requisition Delivery Invoice"],
        },
        component: requisitionDeliveryInvoice,
      },

      
      // {
      //   path: "sale-delivery",
      //   name: "sale-delivery",
      //   meta: {
      //     breadcrumb: ["Inventory", "Sales Invoice Delivery Setup"],
      //   },
      //   component: salesInvoiceDeliverySetup,
      // },
      {
        path: "sale-delivery",
        name: "sale-delivery",
        meta: {
          breadcrumb: ["Inventory", "Sales Delivery Setup"],
        },
        component: salesInvoiceDeliverySetup,
      },
      {
        path: "sale-delivery-records",
        name: "sale-delivery-records",
        meta: {
          breadcrumb: ["Inventory", "Sales Delivery Records"],
        },
        component: salesInvoiceDeliveryRecords,
      },
      {
        path: "view-sale-delivery-invoice",
        name: "view-sale-delivery-invoice",
        meta: {
          breadcrumb: ["Inventory", "Sales Delivery Invoice"],
        },
        component: salesInvoiceDeliveryInvoice,
      },
      {
        path: "sale-invoice-delivery-order/:id",
        name: "sale-invoice-delivery-order",
        meta: {
          breadcrumb: ["Inventory", "Sales Invoice Delivery Order"],
        },
        component: saleInvoiceDeliveryOrder,
      },

      //Gate Pass management  

      {
        path: "add-gate-pass",
        name: "add-gate-pass",
        meta: {
          breadcrumb: ["Inventory", "Gate Pass Setup"],
        },
        component: gatePassSetup,
      },
      {
        path: "gate-pass-record",
        name: "gate-pass-record",
        meta: {
          breadcrumb: ["Inventory", "Gate Pass Records"],
        },
        component: gatePassRecords,
      },
      {
        path: "view-gate-pass-invoice",
        name: "view-gate-pass-invoice",
        meta: {
          breadcrumb: ["Inventory", "Gate Pass Invoice"],
        },
        component: gatePassInvoice,
      },
      {
        path: "product-mapping-report",
        name: "product-mapping-report",
        meta: { breadcrumb: ["Product Mapping Reports"] },
        component: productMappingReport,
      },
      {
        path: "supplier-mapping-report",
        name: "supplier-mapping-report",
        meta: { breadcrumb: ["Supplier Mapping Reports"] },
        component: supplierMappingReport,
      },
      {
        path: "stock-report",
        name: "stock-report",
        meta: { breadcrumb: ["Stock Reports"] },
        component: stockReport,
      },
      {
        path: "delivery-report",
        name: "delivery-report",
        meta: { breadcrumb: ["Delivery Report"] },
        component: deliveryReports,
      },
      {
        path: "gate-pass-report",
        name: "gate-pass-report",
        meta: { breadcrumb: ["Gate Pass Report"] },
        component: gatePassReports,
      },
    ],
  },
];
